import React from "react";
import {imageMap} from "../../images/imageMap.ts";
import Release20151214 from "./releases/Release20151214.tsx";
import Release20160425 from "./releases/Release20160425.tsx";
import Release20160816 from "./releases/Release20160816.tsx";
import Release20171002 from "./releases/Release20171002.tsx";
import Release20180123 from "./releases/Release20180123.tsx";
import Release20181017 from "./releases/Release20181017.tsx";
import Release20230109 from "./releases/Release20230109.tsx";
import Release20230330 from "./releases/Release20230330.tsx";
import Release20230419 from "./releases/Release20230419.tsx";
import Release20230509 from "./releases/Release20230509.tsx";
import Release20230918 from "./releases/Release20230918.tsx";
import Release20231120 from "./releases/Release20231120.tsx";
import Release20240426 from "./releases/Release20240426.tsx";

export type Release = {
    date_human: string;
    img_list: string;
    img_alt: string;
    title: string;
    description: string;
    heading: string;
    subheading: string;
    slug: string;
    content?: (() => React.JSX.Element)
}

export const pressReleases: { [key: string]: Release } = {
    "mest-vaerdi-for-pengene-pressemeddelelse-2024-04-26": {
        "date_human": "26/04-2024",
        "img_list": imageMap.press.press_release_13,
        "img_alt": "Hiper vinder \"mest værdi for pengene\" prisen for 5. år i træk",
        "title": "Hiper giver mest værdi for pengene for 5. gang i træk",
        "description": "Hiper vinder for 5. år i træk Loyalty Group prisen, som det internetselskab der giver kunderne Mest værdi for pengene.",
        "heading": "Hiper giver mest værdi for pengene for 5. gang i træk",
        "subheading": "Hiper vinder for 5. år i træk Loyalty Group prisen, som det internetselskab der giver kunderne Mest værdi for pengene. Hipers direktør Mads Hein mener det er virksomhedens strategiske fokus på stabile og hurtige fiberforbindelser, som bidrager til den solide fastholdelse af førstepladsen.",
        "slug": "mest-vaerdi-for-pengene-pressemeddelelse-2024-04-26",
        "content": Release20240426,
    },
    "sef-fiber-pressemeddelelse-2023-11-20": {
        "date_human": "20/11-2023",
        "img_list": imageMap.press.press_release_12,
        "img_alt": "Nye hustande på Sydfyn kan få fibernet fra Hiper",
        "title": "Nu kan 23.000 husstande på Sydfyn få fiberinternet fra Hiper",
        "description": "Der åbnes op for køb af fiberprodukter fra Hiper for ca. 23.000 husstande og erhvervsadresser i og omkring Svendborg kommune samt på Langeland.",
        "heading": "Nu kan 23.000 husstande på Sydfyn få fiberinternet fra Hiper",
        "subheading": "Den 20. november vil der åbnes op for køb af fiberprodukter fra Hiper for ca. 23.000 husstande og erhvervsadresser i og omkring Svendborg kommune samt på Langeland.",
        "slug": "sef-fiber-pressemeddelelse-2023-11-20",
        "content": Release20231120,
    },
    "globalconnect-fiber-pressemeddelelse-2023-09-18": {
        "date_human": "18/09-2023",
        "img_list": imageMap.press.press_release_10,
        "img_alt": "Hiper fibernet gennem GlobalConnect",
        "title": "50.000 husstande får mulighed for Hiper fibernet gennem GlobalConnect",
        "description": "Det er nu muligt for 50.000 adresser, der er tilkoblet GlobalConnect Privats (tidligere Onefiber) netværk, at vælge Hiper som internetudbyder.",
        "heading": "50.000 danske husstande får nu mulighed for internet fra Hiper gennem GlobalConnect Privats fibernet",
        "subheading": "Fra i dag er det nu muligt for 50.000 adresser, der er tilkoblet GlobalConnect Privats (tidligere Onefiber) netværk, at vælge Hiper som internetudbyder.\n                              Det fejrer Hiper med aktuel kampagne hvor man kan få 1000/1000 Mbit fiberforbindelse til en attraktiv pris.",
        "slug": "globalconnect-fiber-pressemeddelelse-2023-09-18",
        "content": Release20230918,
    },
    "rah-fiber-pressemeddelelse-2023-05-09": {
        "date_human": "09/05-2023",
        "img_list": imageMap.press.press_release_11,
        "img_alt": "En ny aftale mellem RAH og Nuuday",
        "title": "Nyt samarbejde med RAH Fiber",
        "description": "Det nye samarbejde med Nuuday-selskaberne og RAH Fiber skaber flere muligheder for vestjyske fiberkunder, så flere kan få lynhurtigt fibernet.",
        "heading": "Ny aftale mellem Nuuday og RAH Fiber giver flere valgmuligheder til vestjyske fiberkunder",
        "subheading": "Nyt samarbejde mellem RAH Fiber og Nuuday-selskaberne YouSee, Hiper og TDC Erhverv giver 28.000\n                              vestjyske husstande og virksomheder adgang til internet, tv og erhvervsløsninger fra Danmarks største teleselskab.",
        "slug": "rah-fiber-pressemeddelelse-2023-05-09",
        "content": Release20230509,
    },
    "forbrugerundersoegelse-pressemeddelelse-2023-04-19": {
        "date_human": "19/04-2023",
        "img_list": imageMap.press.press_release_10,
        "img_alt": "Mads Hein i spidsen som CEO af Hiper, som er danskernes favoritinternet",
        "title": "Hiper udbygger føringen",
        "description": "Internetudbyderen Hiper udbygger igen sin førerposition, når det kommer til forholdet til de danske kunder, viser ny forbrugerundersøgelse.",
        "heading": "Ny forbrugerundersøgelse: Hiper udbygger føringen som danskernes favoritinternet",
        "subheading": "Internetudbyderen Hiper udbygger igen sin førerposition, når det kommer til forholdet til de danske kunder.\n                              Det viser den seneste store forbrugerundersøgelse fra Loyalty Group, hvor Hiper kåres af forbrugerne som både den udbyder, der giver mest værdi for pengene, og den som flest vil anbefale.\n                              Derudover vinder Nuuday-virksomheden Hiper for første gang prisen som den mest kundevenlige internetudbyder &ndash; og det er ifølge Hipers direktør, Mads Hein, et klart udtryk for virksomhedens succesfulde strategi om at fokusere på fiberinternet.",
        "slug": "forbrugerundersoegelse-pressemeddelelse-2023-04-19",
        "content": Release20230419,
    },
    "globalconnect-pressemeddelelse-2023-03-30": {
        "date_human": "30/03-2023",
        "img_list": imageMap.press.press_release_9,
        "img_alt": "Yousee og Hiper for adgang til GlobalConnect Privats fibernet",
        "title": "Nyt samarbejde med GlobalConnect Privat",
        "description": "Nyt samarbejde med GlobalConnect Privat (tidligere Onefiber) og Nuuday-selskaberne giver endnu flere danskere adgang til lynhurtigt internet.",
        "heading": "YouSee og Hiper får adgang til GlobalConnect Privats fibernet i ny aftale",
        "subheading": "Nyt samarbejde med GlobalConnect Privat (tidligere Onefiber) og Nuuday-selskaberne YouSee og Hiper giver endnu flere danskere adgang til lynhurtigt internet og tv via en fiberforbindelse.\n                              Parterne deler et fælles mål; at give flere valgmuligheder til danskerne.",
        "slug": "globalconnect-pressemeddelelse-2023-03-30",
        "content": Release20230330,
    },
    "100000-kunder-pressemeddelelse-2023-01-09": {
        "date_human": "09/01-2023",
        "img_list": imageMap.press.press_release_8,
        "img_alt": "Mads Hein som er nuværende CEO af Hiper",
        "title": "Hiper når 100.000 kunder",
        "description": "Hiper lægger stærkt ud i 2023 og når en vigtig strategisk milepæl på 100.000 kunder, godt et halvt år tidligere end forventet.",
        "heading": "Hiper runder milepæl på 100.000 kunder længe før forventet",
        "subheading": "Internetudbyderen Hiper lægger stærkt ud i 2023 og når en vigtig strategisk milepæl på 100.000 kunder godt et halvt år tidligere end forventet.\n                              Nu skal der yderligere skub under digitalisering og fiberdækning for Nuuday-virksomheden, som ser frem til at fortsætte kundevæksten.",
        "slug": "100000-kunder-pressemeddelelse-2023-01-09",
        "content": Release20230109,
    },
    "hiper-bliver-en-del-af-tdc-2018-10-17": {
        "date_human": "17/10-2018",
        "img_list": imageMap.press.press_release_7,
        "img_alt": "Hiper bliver en del af TDC",
        "title": "Hiper bliver en del af TDC",
        "description": "Fra 2018 bliver Hiper nu en del af TDC&rsquo;s nyetablerede forretningsenhed OpCo, som et selvstændigt brand.",
        "heading": "Hiper bliver en del af TDC",
        "subheading": "Vi bliver nu en del af TDC&rsquo;s nyetablerede forretningsenhed OpCo, som et selvstændigt brand.",
        "slug": "hiper-bliver-en-del-af-tdc-2018-10-17",
        "content": Release20181017,
    },
    "hiper-og-heroic-gaar-sammen-2018-01-23": {
        "date_human": "23/01-2018",
        "img_list": imageMap.press.press_release_6,
        "img_alt": "Hiper og Heroic går sammen i aftale om lynhurtigt internet",
        "title": "Hiper og Heroic går sammen",
        "description": "Én af årsagerne til, at Danmark trods sin størrelse har indtaget en topposition inden for esport, er netop det tidligt udviklede bredbåndsnet.",
        "heading": "Hiper og Heroic går sammen",
        "subheading": "Lynhurtigt bredbånd til flere!",
        "slug": "hiper-og-heroic-gaar-sammen-2018-01-23",
        "content": Release20180123,
    },
    "fiberfart-paa-kabel-tv-2017-10-02": {
        "date_human": "02/10-2017",
        "img_list": imageMap.press.press_release_5,
        "img_alt": "Med hurtigt internet er det sjovt at surfe på nettet",
        "title": "1.000 Mbit på kabel-tv-stik",
        "description": "Fra oktober 2017 kan op imod ⅓ af danske husstande glæde sig til at få 1.000 Mbit internet, uden at skulle grave forhaven op.",
        "heading": "Fiberfart på kabel-tv nettet",
        "subheading": "Nu kan danskerne få fiberfart på kabel-tv nettet",
        "slug": "fiberfart-paa-kabel-tv-2017-10-02",
        "content": Release20171002,
    },
    "10.000-kunder-pressemeddelelse-2016-08-16": {
        "date_human": "16/08-2016",
        "img_list": imageMap.press.press_release_3,
        "img_alt": "10.000 kunder har valgt bredbånd uden tv",
        "title": "Hiper har fået 10.000 kunder",
        "description": "I 2016 har 10.000 Hiper kunder valgt bredbånd uden tv. Hipers vækst går som lysets hastighed &ndash; og forventer flere kunder endnu.",
        "heading": "I vækst med lysets hastighed",
        "subheading": "Nu vender det — 10.000 kunder har valgt bredbånd uden tv",
        "slug": "10.000-kunder-pressemeddelelse-2016-08-16",
        "content": Release20160816,
    },
    "antennestik-pressemeddelelse-2016-04-25": {
        "date_human": "25/04-2016",
        "img_list": imageMap.press.press_release_2,
        "img_alt": "Smæk benene op på bordet og se flow TV med godt internet",
        "title": "Nyt liv til det gode gamle antennestik",
        "description": "Efter mange års tilløb kan man nu få bredbånd over kabel-tv &ndash; uden et krav om tv-pakker hos Hiper.",
        "heading": "Nyt liv til dit antennestik",
        "subheading": "Efter mange års tilløb kan man nu få bredbånd over kabel-tv — uden tv!",
        "slug": "antennestik-pressemeddelelse-2016-04-25",
        "content": Release20160425,
    },
    "lancering-pressemeddelelse-2015-12-14": {
        "date_human": "14/12-2015",
        "img_list": imageMap.press.press_release_1,
        "img_alt": "Stig Myken som er stifter af Hiper",
        "title": "Danmarks nye bredbåndsselskab",
        "description": "Hiper skriver historie i dag ved at være det første selskab, som åbner for bredbånd på både fiber, kabel-tv og over telefonnettet.",
        "heading": "Danmarks nye bredbåndsselskab",
        "subheading": "Der skrives et lille stykke Danmarkshistorie når Hiper i dag som det første selskab åbner for bredbånd på både fiber, kabel-tv og over telefonnettet.",
        "slug": "lancering-pressemeddelelse-2015-12-14",
        "content": Release20151214,
    }
}
